import Skeleton from 'react-loading-skeleton';

interface IMarketItemProps {

}

export default function MarketItem(props: IMarketItemProps) {

    return (
        <div className='puzzle-nftMarketplace__nftCard'>
            <Skeleton height={275} baseColor="#c6c9f4"/>
            <div className='puzzle-nftMarketplace__info'>
                <div className='puzzle-nftMarketplace__nftCollection'>
                    <Skeleton width="40%"/>
                </div>
                <div className='puzzle-nftMarketplace__nftName'><Skeleton/></div>
            </div>
            <div className='puzzle-nftMarketplace__actions'>
                <div className='puzzle-nftMarketplace__price'>
                    <div className='puzzle-nftMarketplace__priceCaption'>Price</div>
                    <div className='puzzle-nftMarketplace__asset'>
                        <Skeleton width={30}/>
                    </div>
                </div>
                <div>
                    <Skeleton width={100} height={40}/>
                </div>
            </div>
        </div>
    )
}